module.exports = __webpack_public_path__ + "static/avatar_anastasia_spiridonova-3ca0712079e526070a76793c43f173c1.jpg";